import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { isEqual } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class FormStateService {
  public currentFormGroup: NgForm;
  public initialValue: unknown;

  public hasChanged(): boolean {
    if (!this.currentFormGroup?.form || !this.initialValue) {
      return false;
    }

    return !this.compareValues(this.currentFormGroup.form.getRawValue(), this.initialValue);
  }

  public initialize(currentFormGroup: NgForm, initialValue: unknown): void {
    this.currentFormGroup = currentFormGroup;
    this.initialValue = initialValue;
  }

  public reset(): void {
    this.initialValue = null;
  }

  private compareValues(val1: unknown, val2: unknown): boolean {
    if ((val1 === null || val1 === '' || val1 === undefined) && (val2 === null || val2 === '' || val2 === undefined)) {
      return true;
    }

    if (typeof val1 === 'object' && typeof val2 === 'object') {
      if (!val1 || !val2) {
        return false;
      }

      const obj1 = val1 as Record<string, unknown>;
      const obj2 = val2 as Record<string, unknown>;
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      return keys1.every((key) => this.compareValues(obj1[key], obj2[key]));
    }

    return isEqual(val1, val2);
  }
}
